import React from 'react';

import { NumberInput, Select } from '@mantine/core';

const COUNTDOWN_PRESETS = [
  { value: '10', label: '10:00 (EMOM)' },
  { value: '12', label: '12:00 (AMRAP)' },
  { value: '15', label: '15:00' },
  { value: '20', label: '20:00' },
  { value: '3', label: '3:00 (Rest)' },
];

type CountdownOptionsProps = {
  countdownPresetMinutesValue: string;
  handlePresetChange: (value: string | null) => void;
  countdownMinutesValue: number;
  handleCountdownMinutesChange: (value: number) => void;
};

function CountdownOptions({
  countdownPresetMinutesValue,
  handlePresetChange,
  countdownMinutesValue,
  handleCountdownMinutesChange,
}: CountdownOptionsProps): JSX.Element {
  return (
    <>
      <Select
        label='Preset'
        value={countdownPresetMinutesValue}
        onChange={handlePresetChange}
        data={COUNTDOWN_PRESETS}
        withinPortal
      />
      <NumberInput
        label='Custom minutes'
        min={1}
        max={300}
        value={countdownMinutesValue}
        onChange={handleCountdownMinutesChange}
      />
    </>
  );
}

export default CountdownOptions;
